<template>
    <div class="page homepage" :class=" !user ? 'homeNotLogin' : '' ">
        
        <div class="page pb-5 bgcolorCream" v-if="user">
            <TopNavBar/>
            <div class="container pb-5">
                <div class="row pb-5">
                    <div class="col-12" >
                        <RewardsList/>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottomBtn mediaHideOnDesctop" v-if="user">
            <div class="container">
                <router-link class="btnlink zbg" :to="{name: 'Locations'}" >
                    Start order
                </router-link>
            </div>
        </div>
        
        <div class="revHome" v-if="!user">
            <div class="logoBox">
                <img :src="getStaticImage('logo.png')">
            </div>
            <div class="loginFormBox">
                <div class="container">
                    <div class="reginster">
                        <router-link class="btnlink zbg" :to="{name:'Registration'}">Sign Up</router-link>
                    </div>
                    <div class="login">
                        <router-link class="h3" :to="{name:'Login'}">SIGN IN</router-link>
                    </div>
                    <div class="guest">
                        <router-link :to="{name: 'Locations'}" >
                            Continue as guest
                        </router-link>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
</template>

<script>
    import RewardsList from "../components/rewards/RewardsList";
    import TopNavBar from "../components/shared/TopNavBar";

    export default {
        name: 'Home',
        components: {TopNavBar, RewardsList},
        created() {
            if (this.user){
                this.$store.commit("shared/setTopBar", {title: "Home", showBackButton: false, showBag: false});
            }else{
                this.$store.commit("shared/setTopBar", {active: false});
            }
        },
    }
    
</script>
